import Configuration from "../config";

const conf = Configuration.getConfiguration();

export default {
  SUPERADMINROLE: 'SUPERADMIN',
  ADMINROLE: 'ADMIN',
  CASHIERROLE: 'CASHIER',
  PLATFORMROLE: 'PLATFORM',
  STOREROLE: 'STORE',
  PLAYERROLE: 'PLAYER'
}

export const sections = [
  { value: "top_full", label: "Full Top" },
  { value: "center_full", label: "Full Center"},
  { value: "center", label: "Center" },
  { value: "banner_games", label: "Games" },
  { value: "banner_roviders", label: "Proveedores" },
];

export const languages = [
  { label: "Español", value: "ES" },
  { label: "Inglés", value: "EN" },
  { label: "Portugués", value: "PT" },
];

export let status = [
  { value: 0, label: "Desactivo" },
  { value: 1, label: "Activo" },
];

export const sectionVertical = [
  {
    id: 1,
    icon:`${conf.ASSETS}/bo_fontend/icons/home.png`,
    title: "Home",
    options: ["TOP 10", "TOP", "POPULARES", "NUEVOS"],
  },
  {
    id: 2,
    icon:`${conf.ASSETS}/bo_fontend/icons/slot.png`,
    title: "Casino",
    options: ["Todos", "TOP", "POPULARES", "NUEVOS", "VIRTUAL POKER","DROPS & WINS", "MEGAWAYS", "RULETAS" , "VIDEO BINGO", "MESAS"],
  },
  {
    id: 3,
    icon:`${conf.ASSETS}/bo_fontend/icons/slotlive.png`,
    title: "Casino en vivo",
    options: ["Mesas", "Proveedores"],
  },
  {
    id: 4,
    icon:`${conf.ASSETS}/bo_fontend/icons/crash.png`,
    title: "Crash Games",
    options: ["Juegos", "Proveedores"],
  },
  // {
  //   id: 5,
  //   icon: "",
  //   title: "Raspa y gana",
  //   options: ["Juegos", "Premios"],
  // },
  {
    id: 6,
    icon:`${conf.ASSETS}/bo_fontend/icons/virtual.png`,
    title: "Virtuales",
    options: ["Fútbol", "Carreras"],
  },
];